import axios from "axios";
import qs from "qs";

const BASE_URL = import.meta.env.VITE_BACKEND_URL;


export const runUtility = (myCommand) =>
    axios.get(`${BASE_URL}/api/contramatic/app/runUtility`,         {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
        },
        params: {my_command: myCommand}
    })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });